"use client"




import {useEffect, useState} from "react";
import {getAppLanguage} from "@/core/services/localStorage.service";
import {Column} from "@/core/general/column.component";
import {toPersianNumber} from "@/core/utils/number.utils";
import {Row} from "@/core/general/row.component";
import {ENGLISH_APP, PERSIAN} from "@/core/services/CONSTANTS";
import {useTranslations} from "use-intl";
import {CalendarEventsModel} from "@/core/tools/calendar/model/calendarEvents.model";
import momentJalali from 'moment-jalaali';
import moment, {Moment} from 'moment-jalaali';
import momentCivil from 'moment';
import momentHijri from 'moment-hijri';
import {Calendar, DateObject} from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"

interface Props {
    persian: CalendarEventsModel[];
    hijri: CalendarEventsModel[];
    civil: CalendarEventsModel[];
}

export default function CalendarComponent(props:Props){

    const [day, setDay] = useState<Date|null>(null);
    const [persianEvent, setPersianEvent] = useState<CalendarEventsModel[]>([]);
    const [hijriEvent, setHijriEvent] = useState<CalendarEventsModel[]>([]);
    const [civilEvent, setCivilEvent] = useState<CalendarEventsModel[]>([]);
    moment.loadPersian({ dialect: 'persian-modern' });
    const mj = momentJalali();
    mj.locale(getAppLanguage());
    const mh = momentHijri();
    // mh.add(-1,"iDate" as JUnitOfTime)
    const me = momentCivil();
    mh.locale('fa-IR');
    me.locale(getAppLanguage());
    const [persianMoment, setPersianMoment] = useState<Moment>(mj);
    const [hijriMoment, setHijriMoment] = useState<Moment>(mh);
    const [civilMoment, setCivilMoment] = useState<Moment>(me);
    const [hasEvent, setHasEvent] = useState(false);
    const t= useTranslations();

    useEffect(() => {
        const persianArray = props.persian.filter(
            (item) => item.day == persianMoment.jDate() && item.month == persianMoment.jMonth() + 1
        );
        const hijriArray = props.hijri.filter(
            (item) => item.day == hijriMoment.iDate() && item.month == hijriMoment.iMonth() + 1
        );
        const civilArray = props.civil.filter(
            (item) => item.day == civilMoment.date() && item.month == civilMoment.month() + 1
        );
        setPersianEvent(persianArray);
        setHijriEvent(hijriArray);
        setCivilEvent(civilArray);
        setHasEvent(!(persianArray.length == 0 && hijriArray.length == 0 && civilArray.length == 0));
    }, [persianMoment]);

    function selectCalendar(item: DateObject|null) {
        setDay(item?.toDate()??(new Date()))
        const mj = momentJalali(item?.toDate());
        setPersianMoment(mj);
        const items=props.persian.filter(
            (item) => item.month == persianMoment.jMonth() + 1
        )
        const mh = momentHijri(item?.toDate());
        // mh.add(-1,"iDate" as JUnitOfTime)
        mh.locale(getAppLanguage() === PERSIAN ? 'ar-SA' : 'en-US');
        setHijriMoment(mh);
        const me=momentCivil(item?.toDate())
        me.locale(getAppLanguage() === PERSIAN ? 'fa' : 'en');
        setCivilMoment(me);
    }

    return(
        <Column className={"totalCenter relative w-full items-center"}>
            <Column className={"totalCenter relative w-full md:w-2/3 items-center"}>
                {getAppLanguage() === PERSIAN ? (
                    <Calendar
                        calendar={persian}
                        locale={persian_fa}
                        className={"w-full"}
                        value={day}
                        shadow={false}
                        onMonthChange={(item) => selectCalendar(item)}
                        // onSelect={(item) => selectCalendar(item)}
                        onChange={(value) => selectCalendar(value)}
                    />
                ) : (
                    <Calendar
                        calendar={persian}
                        locale={persian_fa}
                        value={day}
                        shadow={false}
                        onMonthChange={(item) => selectCalendar(item)}
                        // onSelect={(item) => selectCalendar(item)}
                        onChange={(value) => setDay(value?.toDate()??(new Date()))}
                    />
                )}
            </Column>
            <Column className={'px-4 w-full md:w-2/3 mt-4'}>
                <Row className={'mBackgroundBlue rounded-lg p-3 mt-2 text-white totalCenter'}>
                    {(`${process.env.NEXT_PUBLIC_NODE_ENV}`.trim() === ENGLISH_APP)?
                        <div className={'text-bold text-2xl w-1/3 text-center'}>{civilMoment.format('dddd')}</div>
                        :
                        <div className={'text-bold text-2xl w-1/3 text-center'}>{persianMoment.format('dddd')}</div>
                    }
                    <div className={'text-bold text-2xl mDivider !bg-white mx-4'} />
                    <div className={'flex flex-col w-2/3 px-4'}>
                        <div className={'text-bold text-sm'}>
                            {toPersianNumber(`${persianMoment.jDate()} ${persianMoment.format('jMMMM')} ${persianMoment.jYear()}`)}{' '}
                            ({t('engineering.shamsi')})
                        </div>
                        <div className={'text-bold text-sm mt-1'}>
                            {toPersianNumber(`${hijriMoment.iDate()} ${hijriMoment.format('iMMMM')} ${hijriMoment.iYear()}`)} (
                            {t('engineering.ghamari')})
                        </div>
                        <div className={'text-bold text-sm mt-1'}>
                            {toPersianNumber(`${civilMoment.date()} ${civilMoment.format('MMMM')} ${civilMoment.year()}`)} (
                            {t('engineering.miladi')})
                        </div>
                    </div>
                </Row>
                {hasEvent && (`${process.env.NEXT_PUBLIC_NODE_ENV}`.trim() !== ENGLISH_APP) ? (
                    <Column className={'mBackgroundLightBlue rounded-lg mt-4 p- text-sm px-2 py-2'}>
                        <div className={'mTextGold text-xl pb-2'}>{t('engineering.events')}</div>
                        {persianEvent?.map((item, index) => (
                            <div key={index} className={`${item.holiday ? 'mTextRed' : 'mText'}`}>
                                {item.holiday ? t('engineering.holidayFor') : ''} {item.title}
                            </div>
                        ))}
                        {hijriEvent?.map((item, index) => (
                            <div key={index} className={`${item.holiday ? 'mTextRed' : 'mText'}`}>
                                {item.holiday ? t('engineering.holidayFor') : ''} {item.title}
                            </div>
                        ))}
                        {civilEvent?.map((item, index) => (
                            <div key={index} className={`${item.holiday ? 'mTextRed' : 'mText'}`}>
                                {item.holiday ? t('engineering.holidayFor') : ''} {item.title}
                            </div>
                        ))}
                    </Column>
                ) : null}
            </Column>
        </Column>
    )
}